<template>
<div class="main--content container">
        <div class="d-flex mt-4 justify-content-between">
            <div>
                <!-- NAVIGATION TAB -->
                <!-- <div class="main--content-header content-header">
                    <div class="content-header--navbar" >
                        <ul class="content-header--navbar-list">
                            <li class="content-header--navbar-list-item" v-bind:class="page == 'company' ? 'active' : ''">
                                <a class="btn content-header--navbar-list-item-link" @click="page = 'company'">Company</a>
                            </li>
                            <li class="content-header--navbar-list-item" v-bind:class="page == 'calendar' ? 'active' : ''">
                                <a class="btn content-header--navbar-list-item-link" @click="page = 'calendar'">Calendar</a>
                            </li>
                        </ul>
                    </div>
                </div> -->
            </div>
        </div>
        <div v-show="page == 'company'" class="mt-3">
            <!--Job Form-->
                <div class="mt-4" style="max-width: 485px">
                    <!--Job Logo --> 
                    <div class="form-group row">
                        <div class="col-12">
                            <label class="form-title" >Company Logo</label>
                            <div class="d-flex no-gutters">
                                <div class="col-3">
                                    <div class="container card" v-if="image_url" >
                                        <img class="img-fluid" :src="image_url" alt="">
                                    </div>
                                    <div  class="container card" v-else style="">
                                        <img style="filter: grayscale(1) brightness(140%);" class="img-fluid p-4" :src="default_logo" alt="">
                                    </div>
                                </div>
                                <div class="col-5 d-flex justify-content-center align-items-center">
                                    <upload-image-button
                                    v-model="image_url"
                                    class="mt-3"
                                    button_class="btn btn-light"
                                    :label="image_url ? 'Change Logo' : 'Upload Logo'"
                                    @file="image_file = $event"
                                    ></upload-image-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Job Name-->
                    <div class="form-group row">
                        <div class="col-md-12">
                            <label class="form-title" for="form-job-name">Company Name</label>
                        </div>
                        <div class="col-md-12">
                            <input id="form-job-name" class="form-control" placeholder="Name" type="text" v-model="company_edit.name" v-bind:class="hasError('company_edit.name') ? 'is-invalid' : ''">
                            <!-- <span v-if="hasError('job.name')" class="invalid-feedback" role="alert">{{ errors['job.name'].join(' ') }}</span> -->
                        </div>
                    </div>

        
                </div>
        </div>
        <!-- CALENDAR TAB -->
        <!-- <div v-show="page != 'company'" class="mt-3">
            <div class="d-flex">
            <div class="justify-content-end mx-2">
                <flatpickr-calendar
                    create_url="breaks_create_url"
                    update_url="breaks_update_url"
                    destroy_url="breaks_destroy_url"
                    :copy_jobs=true
                    :button=true
                ></flatpickr-calendar>
            </div>
            <div class="justify-content-end mx-2">
                <week-work-days
                    class="mx-auto ml-xl-0"
                    :value="company.work_week"
                    save_url="save_work_week_url"
                ></week-work-days>
            </div>
        </div>
        <div class="main--content container">
                <holiday-breaks
                    class="col-xs-12 col-md-12"
                    :value="company.holiday_breaks"
                    create_url="breaks_create_url"
                    update_url="breaks_update_url"
                    destroy_url="breaks_destroy_url"
                    :copy_jobs=true
                ></holiday-breaks>
            </div>
        </div> -->
    </div>
</template>

<script>
	import SearchOrCreateModel from "../general_components/SearchOrCreateModel";
    import CompanyStaffAndPermissions from "../people/CompanyStaffAndPermissions";
    import HolidayBreaks from "../settings/HolidayBreaks.vue";
    import WeekWorkDays from "../settings/WeekWorkDays.vue";
    import FlatpickrCalendar from "../settings/FlatpickrCalendar.vue";
    import UploadImageButton from "../general_components/UploadImageButton";

	import flatpickr from "flatpickr";
	export default {
		name: "CompanySettingsPage",
		components: { SearchOrCreateModel, CompanyStaffAndPermissions, HolidayBreaks, FlatpickrCalendar, WeekWorkDays, UploadImageButton},
		props: [
            'default_logo',
            'save_work_week_url',
            'breaks_destroy_url',
            'breaks_create_url',
            'breaks_update_url',
            'company',
            'store_url',
            'type',
        ],

        data(){
			return {
				company_edit: null,
                
                image_url: '',
				image_file: null,

                saving: false,
                errors: [],
                page:null,
            }
        },

        beforeMount() {
            this.company_edit = this.company;
            this.image_url = this.company.logo_url;
            if (this.type){ this.page = this.type; }

            window.addEventListener('LAYOUT:primary_button', this.save);
           
		},

        methods: {
			hasError(key){
				return !!this.errors[key];
			},

            cancel(){
			   window.location.href = this.back_url.replace('?', '');
            },

			save(){
                this.errors = [];
				let _this = this;

				if (_this.saving)
					return;

				_this.saving = true;

                let formData = new FormData();
                formData.append('name', _this.company_edit.name);
                if (_this.image_file)formData.append('image_file', _this.image_file);

				axios.post(_this.store_url, formData, {
                    headers: {
                        'Content-Type' : 'multipart/form-data',
                        'Accept' : 'application/json'
                    }	
                })
                    .then(function (){
                        _this.saving = false;
                    	window.location.reload();
                    })
                    .catch(function (){
                    	_this.saving = false;
                        Vue.$toast.open({
                            message: 'Couldn\'t save settings',
                            type: 'error'
                        });
                    });
            }
        }
	}
</script>
